import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
  return (
    <main>
      <Outlet />
      <footer className="border-t border-gray-200 bg-white py-4">
        <div className="container mx-auto px-4 text-center text-sm text-gray-500">
        &copy; {new Date().getFullYear()} Veggie World. All rights reserved.
        </div>
      </footer>
    </main>
  );
};

export default DashboardLayout;
